import request from '@/utils/request'

//管理员相关

export function login(data) {
    return request({
        url: '/auth/login',
        method: 'post',
        data
    })
}

export function getInfo(token) {
    return request({
        url: '/auth/info',
        method: 'get',
        params: { token }
    })
}

export function logout() {
    return request({
        url: '/vue-element-admin/user/logout',
        method: 'post'
    })
}


/**
 * 获取管理员列表
 * @returns {AxiosPromise}
 */
export function getSupers(params) {
    return request({
        url: '/admin/index',
        method: 'get',
        params
    })
}


/**
 * 添加管理员
 * @param data
 * @returns {AxiosPromise}
 */
export function addSuper(data) {
    return request({
        url: '/admin/add',
        method: 'post',
        data
    })
}

/**
 * 编辑管理员
 * @param data
 * @returns {AxiosPromise}
 */
export function editSuper(data) {
    return request({
        url: '/admin/edit',
        method: 'post',
        data
    })
}
//删除管理员
export function delSuper(data) {
    return request({
        url: '/admin/del',
        method: 'post',
        data
    })
}
//修改管理员状态
export function changeSuper(data) {
    return request({
        url: '/admin/updateField',
        method: 'post',
        data
    })
}
